import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Layout from '../components/layout/Layout';
import Section from '../components/common/Section';
import Button from '../components/common/Button';

const Card = styled.form`
  max-width: 400px;
  margin: 0 auto;
  padding: 2rem;
  background: var(--background-light);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  color: var(--text-color);

  h1 { margin-bottom: 1.5rem; }
  label { display: block; margin-bottom: 0.5rem; font-weight: 500; }
  input {
    width: 100%;
    padding: 0.75rem;
    border-radius: var(--border-radius);
    border: 1px solid var(--border-color, #333);
    background: var(--background-dark, #111);
    color: var(--text-color);
    margin-bottom: 1rem;
    font-size: 1rem;
  }
  .error {
    color: #ff6b6b;
    margin-bottom: 1rem;
    font-size: 0.9rem;
  }
`;

const AdminLoginPage: React.FC = () => {
  const nav = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await fetch('/api/admin/login', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      if (res.ok) {
        nav('/admin');
        return;
      }
      const data = await res.json().catch(() => ({}));
      setError(data.error || 'Login failed');
    } catch {
      setError('Network error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <Section background="light" padding="large">
        <Card onSubmit={submit}>
          <h1>Admin Login</h1>
          <label htmlFor="pw">Password</label>
          <input
            id="pw"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            required
          />
          {error && <div className="error">{error}</div>}
          <Button type="submit" variant="primary" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </Card>
      </Section>
    </Layout>
  );
};

export default AdminLoginPage;
